function t(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch {
    return e;
  }
}
export {
  t as gracefulDecodeURIComponent
};
//# sourceMappingURL=index54.js.map
